module.exports = __webpack_public_path__ + "img/link.svg?9069d127fcc0d4231b0c37b5eb045de2";